export type LocalizationContent = Record<string, unknown>

export type LocalizationHook<K extends string> = {
  localize: (
    key: K,
    interpolationMap?: Record<string, unknown>,
  ) => string
  setLocale: (locale: SupportedLocale) => void
  getCurrentLocale: () => SupportedLocale
}
export enum SupportedLocale {
  German = 'de',
  English = 'en',
  Chinese = 'zh'
}
export const SUPPORTED_LOCALES = [
  'de',
  'en',
  'zh',
] as readonly SupportedLocale[]
export const DEFAULT_LOCALE: SupportedLocale = SupportedLocale.English